import React, { useState, useEffect } from 'react';
import Convert from 'common/utils/convert-svg-to-png';
import QueryParams from 'admin/utils/QueryParams';
import sectionComponents from 'admin/views/site-designer/modules/sections/components.json';
import states from 'admin/views/site-designer/modules/data.json';
import {
   showcaseDataState,
   libraryDataState,
} from 'admin/views/site-designer/modules/content-data';

import { showcaseComponents, libraryComponents } from 'admin/views/site-designer/modules/sections/content-components';


const MENU_SEGMENT_KEY = 'menu';
const SECTION_SEGMENT_KEY = 'section';
const CREATE_PAGE_SEGMENT_KEY = 'new_page';
const GLOBA_SEGMENT_KEY = 'global';
const PAGE_SEGMENT_KEY = 'page';

const DESIGN_IMAGE_AWS_PATH = 'design/images/';
const DESIGN_VIDEO_AWS_PATH = 'design/videos/';
const INITIAL_NEW_PAGE = {
   name: 'Untitled',
   icon: 'home',
}

const COMING_SOON_SETTINGS = {
   name: 'Coming soon',
   type: 'coming_soon',
   uuid: 'coming_soon',
   is_global: true,
   icon: 'share',
}
const ABOUT_ME_SETTINGS = {
   name: 'About me',
   type: 'about_me',
   uuid: 'about_me',
   is_global: true, icon: 'about',
}


const getGlobalSettings = () => {
   const data = [
      { name: 'Header', type: 'header', uuid: 'header', is_global: true, icon: 'header'  },
      ABOUT_ME_SETTINGS,
      { name: 'Logo', type: 'logo', uuid: 'logo', is_global: true, icon: 'logo'  },
      { name: 'Color', type: 'color', uuid: 'color', is_global: true, icon: 'colors' },
      { name: 'App icon and favicon', type: 'app_icon_and_favicon', uuid: 'app_icon_and_favicon', is_global: true, icon: 'icons' },
      { name: 'Social media links', type: 'social_media_links', uuid: 'social_media_links', is_global: true, icon: 'link' },
      { name: 'SEO & Social sharing', type: 'seo_social_sharing', uuid: 'seo_social_sharing', is_global: true, icon: 'share' },
      COMING_SOON_SETTINGS,
      // { name: 'Fonts', type: 'fonts', uuid: 'fonts', is_global:true,icon: 'text' }, =======================================> (P2)
      // { name: 'Buttons', type: 'buttons', uuid: 'buttons', is_global:true,icon: 'button' }, =======================================> (P2)
      // { name: 'Watermark', type: 'watermark', uuid: 'watermark', is_global:true,icon: 'watermark' }, =======================================> (P2)
      { name: 'Content cards', type: 'content_cards', uuid: 'content_cards', is_global: true, icon: 'content' },
   ];
   return data;
};
const getGlobalSettingsOnPopup = () => {
   const settings = getGlobalSettings().filter(setting => ![COMING_SOON_SETTINGS.uuid, ABOUT_ME_SETTINGS.uuid].includes(setting.uuid));
   return settings;
};

const tryRequire = (path) => {
   try {
      let result = require(`${ path }`)
      return result;
   } catch (err) {
      return null;
   }
};

const importComponent = (path) => {
   return React.lazy(() => import(`${ path }`));
};

function useDynamicComponentImport(name, pathPrefix){
   const [Component, setComponent] = useState(null);
   const [isLoadComponent, setLoadCmponent] = useState(true);
   const [notFoundComponent, setNotFoundComponent] = useState(false);

   useEffect(() => {
      setLoadCmponent(true);
      setComponent(null);
      const path = `${ pathPrefix }/${ name }`;

      const renderComponent = async () => {
         try {
            const modul = await tryRequire(path)
            if(modul){
               const component = importComponent(path);
               setNotFoundComponent(false);
               setComponent(component)
            } else {
               setNotFoundComponent(true);
            }
            setLoadCmponent(false);
         } catch (error) {
            setNotFoundComponent(true);
            setLoadCmponent(false);
         }

      }
      renderComponent();

      return () => {
         setComponent(null);
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [name])
   return {
      Component,
      isLoadComponent,
      notFoundComponent,
   };
}

const DEFAULT_ACCESS = {

   access_for_members_mode: 'all',
   access_for_others_mode: 'all',
   access_members_all: {
      type: 'on',
   },
   access_others_all: {
      type: 'on',
   },
   multiple_access_members: [],
   multiple_access_others: [],
}
function setDevaultIcon(type, siteName, logoSettings, callBack){
   let svg = null;
   let settings = logoSettings;
   if('main' === type) {
      Convert.getGoogleFonts(siteName, (data) => {
         const svg = Convert.logoSvgMaket(logoSettings, siteName);
         const height = 56;
         svg.setAttribute('width', 232);
         svg.setAttribute('height', height)
         const svgElement = document.querySelector('body').appendChild(svg)
         const getfontSize = () => new Promise((resolve) => {
            return resolve(Convert.getfontSize(svgElement))
         });
         getfontSize().then(fontSize => {
            let width = 232;
            const textSvg = svgElement.querySelectorAll('text')[0];
            const textSvgWidth = textSvg.getBoundingClientRect().width;
            if(textSvgWidth + 1 <= 232){
               width = textSvgWidth + 1;
            }
            if(callBack){
               callBack({ fontSize, width })
            }
            document.querySelector('body').removeChild(svg)
         }).catch(e => {
            console.log(e)
         })
      }, [logoSettings?.font_name])
   } else {
      let defaultSettings = logoSettings
      settings = defaultSettings;
      svg = Convert.faviconSvgMaket(defaultSettings, defaultSettings.text);
      return { svg, settings }
   }
}

const addOrRemoveQueryParams = (key, value, isPush = true) => {
   if(value){
      if(isPush){
         QueryParams.pushQueryParam(key, value);
      } else {
         QueryParams.addQueryParam(key, value);
      }
   } else if(QueryParams.getParam(key)) {
      QueryParams.removeQueryParam(key);
   }

}

const getSegmentType = (currentSegment, currentPage) => {
   if(GLOBA_SEGMENT_KEY === currentSegment?.type || (SECTION_SEGMENT_KEY === currentSegment?.type && currentSegment.is_global_settings_section)){
      return GLOBA_SEGMENT_KEY;
   }
   if(!currentPage){
      return MENU_SEGMENT_KEY;
   }
   if(currentPage?.is_new){
      return CREATE_PAGE_SEGMENT_KEY;
   }
   return PAGE_SEGMENT_KEY;
}


const getComponents = () => {
   return {
      ...sectionComponents,
      ...showcaseComponents,
      ...libraryComponents,
   }
}
const getSegmentStates = () => {
   return {
      ...states,
      ...showcaseDataState,
      ...libraryDataState,
   }
}

export {
   getGlobalSettings,
   useDynamicComponentImport,
   MENU_SEGMENT_KEY,
   PAGE_SEGMENT_KEY,
   SECTION_SEGMENT_KEY,
   CREATE_PAGE_SEGMENT_KEY,
   GLOBA_SEGMENT_KEY,
   DEFAULT_ACCESS,
   setDevaultIcon,
   DESIGN_IMAGE_AWS_PATH,
   DESIGN_VIDEO_AWS_PATH,
   addOrRemoveQueryParams,
   getSegmentType,
   getComponents,
   getSegmentStates,
   INITIAL_NEW_PAGE,
   COMING_SOON_SETTINGS,
   getGlobalSettingsOnPopup,
   ABOUT_ME_SETTINGS,
   // getSectionByPage,
}
